// extracted by mini-css-extract-plugin
export var errorsContainer = "_tt-1";
export var link = "_tt-0";